// extracted by mini-css-extract-plugin
export default {"label":"a7ambc"};